import QuestionSources from './QuestionSources';
import DocumentSources from './DocumentSources';
import DetailWebSource from './DetailWebSource';
import Wrapper from './Index';
import WebSources from './WebSources';
import { frontendURL } from '../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/sources'),
      component: DocumentSources,
      props: {
        headerTitle: 'SOURCES.HEADER',
      },
      children: [
        {
          path: '',
          redirect: 'documents',
        },
        {
          path: 'documents',
          name: 'documents_sources',
          roles: ['administrator'],
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/sources'),
      component: QuestionSources,
      props: {
        headerTitle: 'SOURCES.HEADER',
      },
      children: [
        {
          path: 'questions',
          name: 'questions_sources',
          roles: ['administrator'],
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/sources/webs'),
      component: Wrapper,
      props: {
        headerTitle: 'SOURCES.HEADER',
      },
      children: [
        {
          path: '',
          name: 'webs_sources',
          component: WebSources,
          roles: ['administrator'],
        },
        {
          path: ':webId',
          name: 'webs_sources_detail',
          roles: ['administrator'],
          component: DetailWebSource
        },
      ],
    },
  ],
};
